import { map, size } from 'lodash';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';
import { Card, CardBody, CardFooter, CardHeader, Table } from 'reactstrap';
import useTerminalHazardClassSummary from '../hooks/useTerminalHazardClassSummary';
import { Terminal } from '../types/graph';

type TerminalHazardClassSummaryCardProps = { terminal: Terminal };

const TerminalHazardClassSummaryCard = (props: TerminalHazardClassSummaryCardProps) => {

    const { t } = useTranslation('common');
    const { terminal } = props;

    const { url } = useRouteMatch();

    const separateTeus = false;

    const counters = useTerminalHazardClassSummary({ terminal });

    if (size(counters) === 0) {
        return null;
    }

    return <Card style={{ maxHeight: '500px' }}>
        <CardHeader>
            <h4>{t('Classi di pericolo')}</h4>
        </CardHeader>
        <CardBody style={{ padding: 0, overflowX: 'auto' }}>
            <Table style={{ textAlign: 'center', verticalAlign: 'middle' }} striped>
                <thead style={{ position: 'sticky', top: 0, background: 'rgba(255,255,255,.65)', zIndex: 10 }}>
                    <tr>
                        <th rowSpan={separateTeus ? 3 : 2} style={{ verticalAlign: 'middle', position: 'sticky', left: 0, background: 'rgba(255,255,255,.65)' }}>Classe</th>
                        <th colSpan={separateTeus ? 6 : 3}>TEU</th>
                    </tr>
                    <tr>
                        <th colSpan={separateTeus ? 2 : undefined}>A&nbsp;piazzale</th>
                        <th colSpan={separateTeus ? 2 : undefined}>Previsti</th>
                        <th colSpan={separateTeus ? 2 : undefined}>Totali</th>
                    </tr>
                    {separateTeus && <tr>
                        <th>20'</th>
                        <th>40'</th>

                        <th>20'</th>
                        <th>40'</th>

                        <th>20'</th>
                        <th>40'</th>
                    </tr>}
                </thead>

                <tbody>
                    {map(counters, ({ inYard, total, expected }, adrClass) => (
                        <Fragment key={adrClass}>
                            <tr>
                                <th scope="row" rowSpan={separateTeus ? 2 : undefined} style={{ position: 'sticky', left: 0 }}>{adrClass}</th>
                                <td colSpan={separateTeus ? 2 : undefined}>
                                    {inYard[0]}
                                </td>
                                <td colSpan={separateTeus ? 2 : undefined}>
                                    {expected[0]}
                                </td>
                                <td colSpan={separateTeus ? 2 : undefined}>
                                    {total[0]}
                                </td>
                            </tr>
                            {separateTeus && <tr>
                                <td>
                                    {inYard[1]}
                                </td>
                                <td>
                                    {inYard[2]}
                                </td>
                                <td>
                                    {expected[1]}
                                </td>
                                <td>
                                    {expected[2]}
                                </td>
                                <td>
                                    {total[1]}
                                </td>
                                <td>
                                    {total[2]}
                                </td>
                            </tr>}
                        </Fragment>
                    ))}
                </tbody>
            </Table>
        </CardBody>
        <CardFooter>
            <Link to={`${url}/${t('conteggio-teu')}`}>Dettaglio</Link>
        </CardFooter>
    </Card>
};


export default TerminalHazardClassSummaryCard;

